import Flash from "./flash";
import Group from "./group";
import Version from "./version";

export type ProductLog = {
    id: number,
    type: number,
    data: any,
    date: string,
};

export enum ProductModelType {
    LEGACY = 0,
    STANDARD = 1,
};

export enum ProductModelColor {
    BLACK = 0,
    WHITE = 1,
    BLUE = 2,
    PINK = 3,
};

export type ProductModel = {
    type: ProductModelType,
    color: ProductModelColor,
};

type Product = {
    id: string,
    name: string,
    serial_number: string,
    model: ProductModel,
    is_connected: boolean,
    version: Version,
    new_version: Version|null,
    allow_beta_version: boolean,
    brightness: number,
    is_screen_on: boolean,
    night_mode_enabled: boolean,
    night_mode_start: string,
    night_mode_stop: string,
    timezone: number,
    groups: Array<Group>,
    flash: Flash|null,
    latest_logs: Array<ProductLog>,
};

export default Product;
